import Vue from 'vue'
import Vuex from 'vuex'
import axios from'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loaded: false,
		scroll: false,
		siteData: {}	
	},
	getters: {
		work: state => state.siteData.work,
		loaded: state => state.loaded,
		scroll: state => state.scroll
	},
	mutations: {
		setData: (state, payload) => {			
			state.siteData = payload;						
		},

		setLoaded: (state, payload) => {
			state.loaded = payload;
		},

		setScroll: (state, payload) => {
			state.scroll = payload;
		}

	},
	actions: {
		async fetchData({commit}) {			
			const response = await axios.get("json/data.json");			
			commit("setData", response.data);			
		},

		setLoaded({commit}, bool) {
			commit("setLoaded", bool);
		},

		setScroll({commit}, bool) {
			commit("setScroll", bool);
		}
	},
	modules: {
	}
})
